export default "__VITE_ASSET__DE6k884f__"